<template>
  <BasicButton
    class="btn-primary"
    type="submit"
    :isProcessing="isProcessing"
  >
    <slot />
  </BasicButton>
</template>

<script>
  import BasicButton from './BasicButton'

  export default {
    components: {
      BasicButton,
    },

    props: {
      isProcessing: {
        type: Boolean,
      },
    },
  }
</script>

<style>

</style>
